import { create } from 'zustand'

export type AIMessage = { role: 'user' | 'ai'; text: string; cards?: any[]; degraded?: boolean }

type AIPanelState = {
  open: boolean
  context: Record<string, unknown>
  pendingPrompt: string
  messages: AIMessage[]
  setOpen: (v: boolean) => void
  setContext: (c: Record<string, unknown>) => void
  setPendingPrompt: (p: string) => void
  addMessage: (m: AIMessage) => void
  clearMessages: () => void
  resetSession: () => void
}

export const useAIPanel = create<AIPanelState>((set) => ({
  open: false,
  context: {},
  pendingPrompt: '',
  messages: [],
  setOpen: (v) => set({ open: v }),
  setContext: (c) => set({ context: c }),
  setPendingPrompt: (p) => set({ pendingPrompt: p }),
  addMessage: (m) => set((s) => ({ messages: [...s.messages, m] })),
  clearMessages: () => set({ messages: [] }),
  resetSession: () => set({ messages: [], context: {}, pendingPrompt: '' }),
}))
